import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import z from "zod";
import { SubTopicDatabase } from "../../../../types";
import { useUpdateSubTopic } from "../../api/useUpdateSubTopic";
import { enqueueSnackbar } from "../../../../components/GlobalSnackbar/snackbarStore";
import { useState } from "react";
import { isSupabaseError } from "../../../../constants/supabaseErrors";
import { usePermissions } from "../../../../hooks/usePermissions";

const formSchema = z.object({
  notes: z.string().nullable(),
});

type FormValues = z.infer<typeof formSchema>;

export function useNotesTab(subTopic: SubTopicDatabase) {
  const { isAdmin } = usePermissions();
  const { mutateAsync, isPending } = useUpdateSubTopic();

  const [serverError, setServerError] = useState<string | null>(null);

  const form = useForm<FormValues>({
    mode: "onChange",
    defaultValues: {
      notes: subTopic.notes,
    },
    resolver: zodResolver(formSchema),
  });

  async function handleSave(data: FormValues) {
    setServerError(null);

    try {
      await mutateAsync({
        id: subTopic.id,
        command: {
          notes: data.notes,
        },
      });

      enqueueSnackbar('Notes enregistrées', 'success');
    } catch (error) {
      if (isSupabaseError(error)) {
        setServerError(error.message);

        return;
      }
      setServerError("Une erreur est survenue.");
    }
  }

  return {
    isAdmin,
    form,
    serverError,
    handleSave: form.handleSubmit(handleSave),
    isSaving: isPending,
  };
}
